export default "https://cdn-static.gokick.com/assets/e732fce3df71ad981aa0ee65436659b369042414/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";